import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M16 16C15.447 16 15 16.447 15 17V20H5V4H15V7C15 7.552 15.447 8 16 8C16.553 8 17 7.552 17 7V4C17 2.897 16.103 2 15 2H5C3.897 2 3 2.897 3 4V20C3 21.103 3.897 22 5 22H15C16.103 22 17 21.103 17 20V17C17 16.447 16.553 16 16 16Z"
      fill="currentColor"
    />
    <path
      d="M20.644 12L17 8.35498V11H12C11.448 11 11 11.448 11 12C11 12.552 11.448 13 12 13H17V15.645L20.644 12Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Exit');

export default Icon;
